import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, ScrollText } from "lucide-react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACTION_LABELS = {
  login: "Anmeldung",
  "register-qr": "Registrierung (QR)",
};

export default function Weblog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/admin/weblog").then(({ data }) => setLogs(data)).catch(() => {}); }, []);

  return (
    <div className="px-8 py-10">
      <div className="flex items-center gap-3 mb-2">
        <ScrollText className="text-primary" />
        <h1 className="text-3xl font-serif">Weblog</h1>
      </div>
      <p className="text-muted-foreground mb-8 text-sm">Protokoll aller An- und Fehlanmeldungen mit Zeitstempel, IP und System.</p>

      <div className="bg-white border border-border rounded-lg shadow-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Zeit</TableHead>
              <TableHead>E-Mail</TableHead>
              <TableHead>Aktion</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>System</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`weblog-row-${l.id}`}>
                <TableCell className="whitespace-nowrap text-xs">{new Date(l.timestamp).toLocaleString("de-DE")}</TableCell>
                <TableCell className="text-sm">{l.email}</TableCell>
                <TableCell className="text-sm">{ACTION_LABELS[l.action] || l.action}</TableCell>
                <TableCell>
                  {l.success
                    ? <span className="inline-flex items-center gap-1 text-xs text-green-700"><CheckCircle2 size={14} /> Erfolg</span>
                    : <span className="inline-flex items-center gap-1 text-xs text-destructive"><XCircle size={14} /> Fehler</span>}
                </TableCell>
                <TableCell className="text-xs text-muted-foreground">{l.ip}</TableCell>
                <TableCell className="text-xs text-muted-foreground max-w-[240px] truncate" title={l.system}>{l.system}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Keine Einträge.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
